import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { BsDot, BsEnvelope, BsEye, BsPhone, BsPinMap } from "react-icons/bs";
import { GoLocation } from "react-icons/go";

const Footer = () => {
  return (
    <Container fluid className="text-center text-lg-start text-white bgGreen">
      {/* <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
        <div>
          <a href="" className="me-4 text-reset"></a>
          <a href="" className="me-4 text-reset"></a>
          <a href="" className="me-4 text-reset"></a>
          <a href="" className="me-4 text-reset"></a>
          <a href="" className="me-4 text-reset"></a>
          <a href="" className="me-4 text-reset"></a>
        </div>
      </section> */}

      <section className="">
        <Container className="text-left text-md-start pt-5">
          <Row className="mt-3">
            <Col sm="6" md="6" lg="6" xl="4" className="mx-auto mb-4">
              <div className="p-2">
                <div className="py-2">
                  <Image
                    className="logoFooter"
                    src={require("../../assets/white-logo.png")}
                  />
                </div>
                <div className="py-2">
                  <p className="text-white font-normal text-sm">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's ,
                  </p>
                </div>
                <Row>
                  <Col lg="6">
                    <div className="d-flex flex-row gap-2 pt-4">
                      <div>
                        <Image
                          className="w-5/6"
                          src={require("../../assets/facebook.png")}
                        />
                      </div>
                      <div>
                        <Image
                          className="w-5/6"
                          src={require("../../assets/twitter.png")}
                        />
                      </div>
                      <div>
                        <Image
                          className="w-5/6"
                          src={require("../../assets/insta.png")}
                        />
                      </div>
                      <div>
                        <Image
                          className="w-5/6"
                          src={require("../../assets/youtube.png")}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg="6"></Col>
                </Row>
              </div>
            </Col>

            <Col sm="3" md="3" lg="3" xl="4" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-2 text-lg font-semibold">
                Get in Touch
              </h6>
              <div className="d-flex gap-1 align-items-center mt-2">
                <div>
                  <BsPhone style={{ fontSize: "25px" }} />
                </div>
                <div>
                  <h2 className="text-xl font-normal text-white">
                    (00)1234 5467 22
                  </h2>
                </div>
              </div>
              <div className="d-flex gap-1 align-items-center mt-2">
                <div>
                  <BsEnvelope style={{ fontSize: "25px" }} />
                </div>
                <div>
                  <h2 className="text-xl font-normal text-white">
                    info@yourmail.com
                  </h2>
                </div>
              </div>
              <div className="d-flex gap-1 align-items-center mt-2">
                <div>
                  <GoLocation style={{ fontSize: "25px" }} />
                </div>
                <div>
                  <h2 className="text-xl font-normal text-white">
                    165 Sheet, New Avenue, NY, UK
                  </h2>
                </div>
              </div>
            </Col>

            <Col sm="3" md="3" lg="3" xl="4" className="mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-2 text-xl font-semibold">
                Account
              </h6>
              <div className="align-items-center mt-2">
                <h2 className="text-xl font-normal text-white">About Us</h2>
              </div>
              <div className="align-items-center mt-2">
                <h2 className="text-xl font-normal text-white">
                  Privacy Policy
                </h2>
              </div>
              <div className="align-items-center mt-2">
                <h2 className="text-xl font-normal text-white">Terms of</h2>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="webkit py-3">
            <h2 className="text-footer">
              © 2022. All Rights Reserved And Design by Deskworksol
            </h2>
          </div>
        </Container>
      </section>
    </Container>
  );
};

export default Footer;
